import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Body, SubmitButton, Field, FormCadastro, GroupField, Input, PageHeader, View, Select, Spin } from '@components';
import App from '@app';
import { getConfiguracao } from '@ducks/conectoresConfiguracoes';
import { Notification } from '@utils';
import { getTodosClientes } from '@sdk/Clientes';
import { postDuplicacao, reset } from '@ducks/conectoresDuplicacao';

export default function Duplicacao() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [form] = FormCadastro.useForm();
  let { id, idCliente } = useParams();
  idCliente = parseInt(idCliente);
  const [prefixIdentify, setPrefixIdentify] = useState(null);
  const [idClienteSelecionado, setIdClienteSelecionado] = useState(idCliente);
  const [clientes, setClientes] = useState([]);
  const identifyRef = useRef(null);

  const configuracao = useSelector(({ conectoresConfiguracoes }) => conectoresConfiguracoes.get('configuracao'));
  const successConfiguracao = useSelector(({ conectoresConfiguracoes }) => conectoresConfiguracoes.get('successConfiguracao'));
  const postingDuplicacao = useSelector(({ conectoresDuplicacao }) => conectoresDuplicacao.get('postingDuplicacao'));
  const successPostDuplicacao = useSelector(({ conectoresDuplicacao }) => conectoresDuplicacao.get('successPostDuplicacao'));
  const idDuplicado = useSelector(({ conectoresDuplicacao }) => conectoresDuplicacao.get('idDuplicado'));

  useEffect(() => {
    successConfiguracao && setPrefixIdentify(getPrefix(configuracao.conectorIdentify));
  }, [successConfiguracao]);

  useEffect(() => {
    if (successPostDuplicacao) {
      history.push(`/conectores/configuracao/${idClienteSelecionado}/${idDuplicado}/informacoes`);
      dispatch(reset());
    }
  }, [successPostDuplicacao]);

  useEffect(() => {
    form.setFieldsValue({ conectorIdentify: prefixIdentify });
  }, [prefixIdentify]);

  useEffect(() => {
    form.setFieldsValue({ idCliente });
  }, [idCliente]);

  useEffect(() => {
    dispatch(getConfiguracao(id));
  }, [id]);

  const getIdentify = () => (configuracao && configuracao.conectorIdentify ? configuracao.conectorIdentify : '');
  const getPrefix = (identify) => {
    const identifySplit = identify.split('-');

    return `${identifySplit[0]}-${identifySplit[1]}-`;
  };

  const getClientes = async () => {
    let clientesApi = await getTodosClientes();
    clientesApi.shift();

    setClientes(clientesApi);

    clientesApi = clientesApi.map(({ value, title }) => ({
      key: value,
      value,
      title,
    }));

    return clientesApi;
  };

  const handleSubmit = (data) => {
    if (prefixIdentify === data.conectorIdentify) {
      Notification.error(
        <View>
          O identify precisa ser diferente do prefixo <strong>{prefixIdentify}</strong>
        </View>
      );

      return;
    }
    if (prefixIdentify !== data.conectorIdentify.substr(0, prefixIdentify.length)) {
      Notification.error(
        <View>
          O identify precisa ter o prefixo <strong>{prefixIdentify}</strong>
        </View>
      );
      return;
    }
    delete data.idCliente;

    data.idConfiguracao = id;

    dispatch(postDuplicacao(data));
  };

  const handleChangeCliente = (value) => {
    if (!value) return;

    setIdClienteSelecionado(value);
    identifyRef && identifyRef.current && identifyRef.current.focus();

    const cliente = clientes.find((cli) => cli.value === value);

    setPrefixIdentify(`${cliente.key}-`);
  };

  return (
    <App>
      <Body>
        <PageHeader title={`Duplicação do conector ${getIdentify()}`} onBack={() => history.goBack()}>
          <FormCadastro form={form} hideRequiredMark onFinish={handleSubmit}>
            <GroupField>
              <Field label='Cliente' name='idCliente' rules={[{ required: true, message: 'Informe o cliente' }]}>
                <Select
                  form={form}
                  id='idCliente'
                  name='idCliente'
                  action={() => getClientes()}
                  placeholder='Selecione um cliente'
                  onChange={(value) => handleChangeCliente(value)}
                  autoFocus
                />
              </Field>
              <Field label='Identify do novo conector' name='conectorIdentify' rules={[{ required: true, message: 'Informe o identify' }]}>
                <Input autoFocus ref={identifyRef} />
              </Field>
            </GroupField>

            {idCliente && idClienteSelecionado && idCliente !== idClienteSelecionado && (
              <GroupField>
                <Field label='Token do cliente' name='token' rules={[{ required: true, message: 'Informe o token' }]}>
                  <Input />
                </Field>
              </GroupField>
            )}

            {prefixIdentify && (
              <View>
                <View>
                  <strong>Informações</strong>
                </View>

                <ul>
                  <li>
                    O identify precisa ter o prefixo <strong>{prefixIdentify}</strong>
                  </li>
                  <li>
                    O identify precisa ser diferente do prefixo <strong>{prefixIdentify}</strong>
                  </li>
                  {idCliente && idClienteSelecionado && idCliente !== idClienteSelecionado && (
                    <li>
                      O token do cliente pode ser encontrado no menu <strong>Clientes</strong> acessando o{' '}
                      <strong>
                        <a href='https://teammove.app/' target='_blank' rel='noopener noreferrer'>
                          TeamMove
                        </a>
                      </strong>{' '}
                      com o usuário <strong>webmaster</strong>
                    </li>
                  )}
                  <li>
                    O que será duplicado:
                    <ul>
                      <li>Configuração</li>
                      <li>Conexões</li>
                      <li>Cabeçalhos das requisições HTTPS (Header/Header-Value)</li>
                      <li>Fontes de dados e relacionamentos com templates</li>
                      <li>Tarefas</li>
                      <li>Horário de funcionamento</li>
                    </ul>
                  </li>
                  <li>O Conector duplicado estará automaticamente na última versão</li>
                  <li>Após a duplicação, verificar as Conexões</li>
                </ul>
              </View>
            )}

            <SubmitButton type='success' htmlType='submit' ghost={postingDuplicacao} disabled={postingDuplicacao}>
              {postingDuplicacao && <Spin />}&nbsp;Duplicar
            </SubmitButton>
          </FormCadastro>
        </PageHeader>
      </Body>
    </App>
  );
}
